import axios from "axios";
import { store } from '../store/index';


/*
	Axios Interceptors
	then() 이나 catch() 로 처리되기 전에 요청이나 응답을 가로챌 수 있습니다.
*/

axios.interceptors.request.use(
  function(config) {
    store.state.loading = true;
    // 요청을 보내기 전에 수행할 일
    // axios 설정값에 대해 작성
    // ...
    return config;
  },
  function(error) {
    // 오류 요청을 보내기전 수행할 일
    // ...
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    store.state.loading = false;
    // 응답 데이터를 가공
    /*
			http status가 200인 경우
			응답 바로 직전에 대해 작성
			.then() 으로 이어짐
		*/
    // ...
    return response;
  },
  function(error) {
    store.state.loading = false;
    // 오류 응답을 처리
    /*
			http status가 200이 아닌 경우
			응답 에러 처리를 작성
			.catch() 로 이어짐
		*/
    // ...
    //alert(error.response.status);
    //console.log(error);
    // if (error.response.status === 401) {
    //   alert("권한이 없습니다.");
    // }
    return Promise.reject(error);
  }
);
